import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FileUp, Upload } from 'lucide-react';
import { parseDxf } from '@/lib/api';
import { toast } from 'sonner';
import { IDS } from '@/constants/testIds/wizard';

export const DxfDialog = ({ open, onOpenChange, onApply }) => {
  const [contours, setContours] = useState([]);
  const [selected, setSelected] = useState(0);
  const [file, setFile] = useState(null);
  const [scale, setScale] = useState(1);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);

  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    try {
      const res = await parseDxf(f);
      setContours(res.contours || []);
      setSelected(0);
      toast.success(`${res.contours?.length || 0} kontur betoltve`);
    } catch (err) {
      toast.error('DXF parsolasi hiba');
    }
  };

  const apply = () => {
    const contour = contours[selected] || [];
    const transformed = contour.map(([x, y]) => [x * scale + offsetX, y * scale + offsetY]);
    onApply(transformed);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileUp className="h-4 w-4 text-primary" /> DXF import kontur</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground">DXF fajl importalasa konturhoz.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">DXF fajl</Label>
            <Input type="file" accept=".dxf" onChange={handleFile} data-testid={IDS.dxf.file} className="bg-black/30" />
          </div>
          {contours.length > 0 && (
            <>
              <div>
                <Label className="text-xs">Kontur valasztas ({contours.length} db)</Label>
                <select className="w-full h-9 rounded-md bg-black/30 border border-border p-2 text-sm" value={selected} onChange={e => setSelected(parseInt(e.target.value, 10))}>
                  {contours.map((c, i) => <option key={i} value={i}>Kontur #{i + 1} ({c.length} pont)</option>)}
                </select>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div><Label className="text-xs">Skala</Label><Input type="number" step="0.1" value={scale} onChange={e => setScale(parseFloat(e.target.value || '1'))} /></div>
                <div><Label className="text-xs">Offset X</Label><Input type="number" value={offsetX} onChange={e => setOffsetX(parseFloat(e.target.value || '0'))} /></div>
                <div><Label className="text-xs">Offset Y</Label><Input type="number" value={offsetY} onChange={e => setOffsetY(parseFloat(e.target.value || '0'))} /></div>
              </div>
              <div className="flex justify-end">
                <Button onClick={apply} data-testid={IDS.dxf.import}><Upload className="h-4 w-4 mr-1" /> Alkalmazas mint kontur</Button>
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DxfDialog;
